if (!customElements.get('saho-gallery-nav')) {
  customElements.define('saho-gallery-nav', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('[data-saho-gallery]');
      this.slider = this.gallery?.querySelector('[data-product-single-media-slider]');
      if (!this.slider) return;
      this.current = this.querySelector('[data-gallery-current]');
      this.total = this.querySelector('[data-gallery-total]');
      this.dotsContainer = this.querySelector('.saho-gallery-controls__track');
      this.dotsContainer?.removeAttribute('aria-hidden');
      this.sync = this.sync.bind(this);
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.slider, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      document.addEventListener('theme:resize:width', this.sync);
      this.sync();
      customElements.whenDefined('product-info').then(() => {
        if (this.isConnected) requestAnimationFrame(this.sync);
      });
    }
    sync() {
      const carousel = window.theme?.Flickity?.data(this.slider);
      const count = carousel?.cells?.length || 0;
      const ready = Boolean(carousel?.isActive && count > 1);
      this.hidden = !ready;
      this.gallery.toggleAttribute('data-saho-gallery-ready', ready);
      if (!ready) return;
      if (this.dotsContainer && this.dots?.length !== count) {
        this.dots = Array.from({length: count}, (_, position) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'saho-gallery-dot';
          dot.dataset.gallerySlide = String(position);
          dot.setAttribute('aria-label', `${position + 1} / ${count}`);
          return dot;
        });
        this.dotsContainer.replaceChildren(...this.dots);
      }
      const start = Math.max(0, Math.min(carousel.selectedIndex - 3, count - 7));
      this.dots?.forEach((dot, position) => {
        dot.hidden = position < start || position >= start + 7;
        dot.setAttribute('aria-current', position === carousel.selectedIndex ? 'true' : 'false');
      });
      const current = String(carousel.selectedIndex + 1);
      if (this.current.textContent !== current) this.current.textContent = current;
      if (this.total.textContent !== String(count)) this.total.textContent = String(count);
    }
    onClick(event) {
      const button = event.target.closest('[data-gallery-direction], [data-gallery-slide]');
      if (!button || !this.contains(button)) return;
      const carousel = window.theme?.Flickity?.data(this.slider);
      if (!carousel?.isActive) return;
      event.preventDefault();
      event.stopPropagation();
      const instant = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (button.hasAttribute('data-gallery-slide')) carousel.select(Number(button.dataset.gallerySlide), true, instant);
      else if (button.dataset.galleryDirection === 'previous') carousel.previous(true, instant);
      else carousel.next(true, instant);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('theme:resize:width', this.sync);
    }
  });
}

if (!customElements.get('saho-service-strip')) {
  customElements.define('saho-service-strip', class extends HTMLElement {
    connectedCallback() {
      this.offsetFrame = 0;
      this.section = this.closest('product-info');
      this.bar = this.section?.querySelector('cart-bar');
      if (!this.bar) return;
      this.desktop = window.matchMedia('(min-width: 1024px)');
      this.updateOffset = this.updateOffset.bind(this);
      this.scheduleOffset = () => {
        if (this.offsetFrame) return;
        this.offsetFrame = requestAnimationFrame(() => {
          this.offsetFrame = 0;
          if (this.isConnected) this.updateOffset();
        });
      };
      this.resizeObserver = new ResizeObserver(this.scheduleOffset);
      this.resizeObserver.observe(this.bar);
      this.barObserver = new MutationObserver(this.scheduleOffset);
      this.barObserver.observe(this.bar, { attributes: true, attributeFilter: ['class', 'data-position', 'hidden'] });
      this.desktop.addEventListener('change', this.scheduleOffset);
      this.bar.addEventListener('focusin', this.scheduleOffset);
      this.bar.addEventListener('focusout', this.scheduleOffset);
      window.addEventListener('resize', this.scheduleOffset, { passive: true });
      window.visualViewport?.addEventListener('resize', this.scheduleOffset, { passive: true });
      this.updateOffset();
    }
    updateOffset() {
      const visible = this.desktop.matches &&
        this.bar.dataset.position !== 'top' &&
        !this.bar.hidden &&
        (this.bar.classList.contains('is-visible') || this.bar.matches(':focus-within'));
      const height = visible ? this.bar.getBoundingClientRect().height : 0;
      const offset = height > 0 ? Math.ceil(height) + 8 : 0;
      this.style.setProperty('--saho-cart-bar-offset', offset + 'px');
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.barObserver?.disconnect();
      this.desktop?.removeEventListener('change', this.scheduleOffset);
      this.bar?.removeEventListener('focusin', this.scheduleOffset);
      this.bar?.removeEventListener('focusout', this.scheduleOffset);
      window.removeEventListener('resize', this.scheduleOffset);
      window.visualViewport?.removeEventListener('resize', this.scheduleOffset);
      if (this.offsetFrame) cancelAnimationFrame(this.offsetFrame);
    }
  });
}
